import { Design } from '@app/types';

const defaultGlobalLoopHandling = {
  inARow: '',
  lastLocalChange: 0,
  xAndOut: ''
};

const defaultIntentHandling = {
  inARowLimit: 3,
  inARowLimitLastLocalChange: 0,
  xAndOutLimit: 3,
  xAndOutLimitLastLocalChange: 0
};

const defaultOmniChannel = {
  isOmniChannel: false,
  lastLocalChange: 0
};

/**
 * Normalize @see Design settings not part of @see DesignRootSettings due to being too old.
 *
 * @note Destructive on the given object; only call from the design-load pipeline.
 * @note @see normalizeRootSettings normalizes @see DesignRootSettings.
 */
export function normalizeLegacySettings(serialized: Design) {
  const legacySerialized = serialized as Design & {
    /** @deprecated Use @see CanvasTabsState.activeTabId instead. */
    currentActiveTab?: string;
    /** @deprecated Unused for a long time. */
    previousActiveTab?: string;
    /** @deprecated Use @see rootModuleId instead. */
    rootModule?: string;
  };

  delete legacySerialized.currentActiveTab;
  delete legacySerialized.previousActiveTab;
  delete legacySerialized.rootModule;

  serialized.globalLoopHandling = {
    ...defaultGlobalLoopHandling,
    ...serialized.globalLoopHandling
  };

  serialized.intentHandling = {
    ...defaultIntentHandling,
    ...serialized.intentHandling
  };

  serialized.languages ??= [];
  serialized.languages = serialized.languages.map((language) => {
    return {
      ...language,
      voice: language.voice || ''
    };
  });

  serialized.omniChannel = {
    ...defaultOmniChannel,
    ...serialized.omniChannel
  };
}
